import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/pro-solid-svg-icons/faPlus';
import React, { useState, useCallback } from 'react';

import classnames from 'classnames';
import { FormattedMessage } from 'react-intl';

import { Button } from 'ui-components/components/button';

import { TaxIdentifiers as TaxIdentifierEnums } from '../../../enums/tax-identifiers/tax-identifiers';
import { useTaxIdentifiers } from '../../../hooks/use-tax-identifier';
import AddTaxIdentifierModal from './add-tax-identifier-modal';
import DeleteTaxIdentifierModal from './delete-tax-identifier-modal';
import messages from './messages';
import style from './style.module.less';
import TaxIdentifierRow from './tax-identifier-row';

const TaxIdentifiers = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [deleteModalId, setDeleteModalId] = useState();
  const { taxIdentifiers, addSellerTaxIdentifier, deleteSellerTaxIdentifier } = useTaxIdentifiers({ includeInactive: false });
  const toggleModal = useCallback(() => {
    setIsModalOpen(!isModalOpen);
  }, [isModalOpen]);

  const closeDeleteModal = useCallback(() => {
    setDeleteModalId(null);
  }, [setDeleteModalId]);

  const openDeleteModal = useCallback(
    (taxIdentifierId) => {
      setDeleteModalId(taxIdentifierId);
    },
    [setDeleteModalId],
  );

  const onDelete = useCallback(
    async (taxIdentifierId) => {
      await deleteSellerTaxIdentifier(taxIdentifierId);
      closeDeleteModal();
    },
    [closeDeleteModal, deleteSellerTaxIdentifier],
  );

  const onAdd = useCallback(
    async (identifierData) => {
      await addSellerTaxIdentifier(identifierData);
      setIsModalOpen(false);
    },
    [setIsModalOpen, addSellerTaxIdentifier],
  );

  const pendoTrackingId = taxIdentifiers.length
    ? '/settings/international#add-another-tax-identifier'
    : '/settings/international#add-a-tax-identifier';

  return (
    <>
      {taxIdentifiers.length ? (
        <>
          <div className={style['tax-id-grid']}>
            <div className={style['header-cell']}>
              <FormattedMessage {...TaxIdentifierEnums.taxIdentifierType.messageDescriptor} />
            </div>
            <div className={style['header-cell']}>
              <FormattedMessage {...TaxIdentifierEnums.taxIssuingAuthority.messageDescriptor} />
            </div>
            <div className={style['header-cell']}>
              <FormattedMessage {...TaxIdentifierEnums.taxNumber.messageDescriptor} />
            </div>
            <div className={style['header-cell']}>
              <FormattedMessage {...TaxIdentifierEnums.taxNickname.messageDescriptor} />
            </div>
            <div className={classnames([style['header-cell']], style['description-cell'])}>
              <FormattedMessage {...TaxIdentifierEnums.taxDescription.messageDescriptor} />
            </div>
            <div className={style['header-cell']} />
            {taxIdentifiers?.map((row) => (
              <React.Fragment key={row.taxIdentifierId}>
                <TaxIdentifierRow openDeleteModal={openDeleteModal} taxIdentifier={row} />
              </React.Fragment>
            ))}
          </div>
          <Button className={style['add-another-table-button']} onClick={toggleModal} pendoTrackingId={pendoTrackingId} theme='link'>
            <FontAwesomeIcon className={style.icon} icon={faPlus} />
            <FormattedMessage {...messages.addAnotherTaxIdentifier} />
          </Button>
        </>
      ) : (
        <>
          <div className={style.subtext}>
            <FormattedMessage {...messages.addTaxIdentifier} />
          </div>
          <div className={style['add-tax-id-wrapper']}>
            <Button className={style['add-tax-id-button']} onClick={toggleModal} pendoTrackingId={pendoTrackingId} theme='primary'>
              <FormattedMessage {...messages.addATaxIdentifier} />
            </Button>
          </div>
        </>
      )}
      {deleteModalId && <DeleteTaxIdentifierModal onClose={closeDeleteModal} onDelete={onDelete} taxIdentifierId={deleteModalId} />}
      {isModalOpen && <AddTaxIdentifierModal onAdd={onAdd} onClose={toggleModal} taxIdentifiers={taxIdentifiers} />}
    </>
  );
};

export default TaxIdentifiers;
